import IMG1 from "../../pictures/paint1.jpg";
import IMG2 from "../../pictures/paint2.jpg";
import IMG3 from "../../pictures/paint3.jpg";
import IMG4 from "../../pictures/paint4.jpg";
import IMG5 from "../../pictures/paint5.jpg";
import IMG6 from "../../pictures/paint6.jpg";

const uniqueCardsArray = [
  {
    type: "paint1",
    image: IMG1,
  },
  {
    type: "paint2",
    image: IMG2,
  },
  {
    type: "paint3",
    image: IMG3,
  },
  {
    type: "paint4",
    image: IMG4,
  },
  {
    type: "paint5",
    image: IMG5,
  },
  {
    type: "paint6",
    image: IMG6,
  },
 
];

export default uniqueCardsArray;